import React from 'react';
import { Text } from 'recharts';

import { formatOrderCount } from 'features/dashboard/utils/formatOrderCount';

import { useStyles } from './styles';

type CustomTickProps = {
  payload: {
    value: number;
  };
};
export const YAxisTick = (props: CustomTickProps) => {
  const classes = useStyles();

  return (
    <Text {...props} className={classes.tick}>
      {formatOrderCount(props.payload.value)}
    </Text>
  );
};
